export default "<div id=\"{{id}}\" ></div> <!--class=\"video\"-->\r\n"